import { Button, Grid, MenuItem, Typography } from "@material-ui/core";
import { SelectValidator, TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import "moment/locale/es";

import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useForm } from "../../../hooks/useForm";
import { postAnularComprobantePorCancelacion } from "../../../actions/coseguros/coseguros";
import { confirmarAsistenciaTurno } from "../../../actions/turnos/agenda";

import { TURNOS_PERMISOS } from "../../../utils/permisos";
import { validarSoloUnPermiso } from "../../../helpers/permisos";

import { AlertConfirmDevolucion } from "./AlertConfirmDevolucion";
import { fetchMediosPago } from "../../../actions/cbos/medioPago";
import { OBRAS_SOCIALES } from "../../../utils/constants";

export const FormularioDevolucionMonto = (props) => {
  const dispatch = useDispatch();
  const formRef = useRef(null);

  const { permisos: permisosUser } = useSelector((state) => state.auth);
  const { items: mediosPago } = useSelector( state => state.medioPago ); 

  const [openModalAlertPago, setOpenModalAlertPago] = useState(false);
  const [datosAlertDevolucion, setDatosAlertDevolucion] = useState({
    titulo: "",
    mensaje: "",
    sinDevolucion: false,
  });

  const initialValues = {
    nroLote: "",
    nroCupon: "",
    idMedioPago: ""
  };

  const [formValues, handleInputChange] = useForm(initialValues);

  const { nroLote, nroCupon, idMedioPago } = formValues;

  const closeModalAlertPagoHandler = () => {
    setOpenModalAlertPago(false);
  };

  useEffect(() => {
    dispatch(fetchMediosPago());
  }, [dispatch]);

  const openModalAlertPagoHandler = async (sinDevolucion) => {
    let isFormValid = false;

    if (sinDevolucion) {
      isFormValid = await formRef.current.isFormValid(true);
    } else {
      isFormValid = await formRef.current.isFormValid(false);
    }

    if (isFormValid || sinDevolucion) {
      setDatosAlertDevolucion({
        titulo: sinDevolucion
          ? "Cancelar Asistencia sin devolución"
          : "Cancelar Asistencia con devolución",
        mensaje: sinDevolucion
          ? "sin devolución del monto"
          : "con devolución del monto",
        sinDevolucion,
      });
      setOpenModalAlertPago(true);
    }
  };

  const onSubmitPagoCoseguroHandler = (sinDevolucion) => {
    const dataPost = {
      idAgenda: props.idAgenda,
      nroLote: sinDevolucion ? null : Number(nroLote),
      nroCupon: sinDevolucion ? null : Number(nroCupon),
      importeDevuelto: sinDevolucion ? null : props.monto,
      idMedioPago: sinDevolucion ? null : Number(idMedioPago),
    };

    dispatch(
      postAnularComprobantePorCancelacion(
        dataPost,
        props.closeModalDevolucionMonto,
        confirmarAsistenciaTurno,
        props.idAgenda
      )
    );
  };

  return (
    <React.Fragment>
      <AlertConfirmDevolucion
        open={openModalAlertPago}
        closeAlertModal={closeModalAlertPagoHandler}
        datosAlertDevolucion={datosAlertDevolucion}
        confirmButtonAction={onSubmitPagoCoseguroHandler.bind(
          this,
          datosAlertDevolucion?.sinDevolucion
        )}
      />
      <ValidatorForm ref={formRef}>
        <Grid
          container
          spacing={2}
          style={{ width: "60%", margin: "auto", marginBottom: "0.7rem" }}
        >
          <Grid item xs={12}>
            <Typography variant="h5" style={{ textAlign: "center" }}>
              Monto: ${props.monto.toFixed(2)}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h6" style={{ textAlign: "center" }}>
              {new Date().toLocaleDateString()}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <TextValidator
              fullWidth
              autoComplete="off"
              style={{ marginTop: 0 }}
              margin="normal"
              label="Nro. Lote"
              name="nroLote"
              value={nroLote}
              onChange={handleInputChange}
              validators={[
                "required",
                "matchRegexp:^[0-9]+$",
                "minNumber: 1",
                "maxNumber: 999999999",
              ]}
              errorMessages={[
                "Campo obligatorio",
                "Solo se permiten números positivos enteros",
                "No puede ser 0",
                "Solo se permite un maximo de 9 caracteres númericos",
              ]}
            />
          </Grid>
          <Grid item xs={12}>
            <TextValidator
              fullWidth
              autoComplete="off"
              style={{ marginTop: 0 }}
              margin="normal"
              label="Nro. Cupón"
              name="nroCupon"
              value={nroCupon}
              onChange={handleInputChange}
              validators={[
                "required",
                "matchRegexp:^[0-9]+$",
                "minNumber: 1",
                "maxNumber: 9999999999",
              ]}
              errorMessages={[
                "Campo obligatorio",
                "Solo se permiten números positivos enteros",
                "No puede ser 0",
                "Solo se permite un maximo de 10 caracteres númericos",
              ]}
            />
          </Grid>
          <Grid item xs={12}>
            <SelectValidator
              value={idMedioPago}
              style={{marginBottom: 10}}
              onChange={(e) => {
                handleInputChange(e);
              }}
              label="Medio de Pago"
              name="idMedioPago"
              validators={["required"]}
              errorMessages={["El Medio de Pago es requerido"]}
              fullWidth
            >
              <MenuItem value="">
                <em>Seleccione</em>
              </MenuItem>
              {validarSoloUnPermiso(permisosUser,
                TURNOS_PERMISOS.PERMITE_SELECCIONAR_MEDIOS_PAGO_NO_HABILITADOS)
                ?
                  mediosPago.map((item) => (
                    <MenuItem key={item.idMedioPago} value={item.idMedioPago}>
                      {item.descripcion}
                    </MenuItem>
                  ))
                :
                  mediosPago.filter(s => s.habilitado).map((item) => (
                    <MenuItem key={item.idMedioPago} value={item.idMedioPago}>
                      {item.descripcion}
                    </MenuItem>
                  ))
              }
            </SelectValidator>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid
            item
            xs={12}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-evenly",
              margin: "1.5rem 0",
            }}
          >
            <Button
              color="primary"
              variant="contained"
              onClick={openModalAlertPagoHandler.bind(this, true)}
              disabled={nroLote.length > 0 || nroCupon.length > 0
                || (props.idObraSocial !== OBRAS_SOCIALES.OSPEDYC && props.idObraSocial !== undefined)}
            >
              Cancelar Sin Devolución
            </Button>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid
            item
            xs={12}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-evenly",
              margin: "1.5rem 0",
            }}
          >
            <Button
              style={{ margin: "0 1rem" }}
              color="secondary"
              variant="contained"
              onClick={props.closeModalDevolucionMonto}
            >
              Cancelar
            </Button>
            <Button
              color="primary"
              variant="contained"
              onClick={openModalAlertPagoHandler.bind(this, false)}
            >
              Confirmar Devolución
            </Button>
          </Grid>
        </Grid>
      </ValidatorForm>
    </React.Fragment>
  );
};
